import { landingImages } from "helpers/images";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useState } from "react";

const DiscountBanner = () => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className="fixed bottom-4 right-4 landing-3xs:bottom-6 landing-3xs:right-6 z-50">
      <div className="flex justify-between items-center">
        {!isOpen && (
          <div
            className="w-10 h-10 landing-sm:w-16 landing-sm:h-16  relative rounded-full bg-black cursor-pointer"
            onClick={() => setIsOpen(!isOpen)}
          >
            <img
              className="absolute bottom-2 left-2 w-12 h-12 landing-sm:w-20 landing-sm:h-20 object-contain"
              src={landingImages.discountTag}
              alt="Discount"
            />
          </div>
        )}
      </div>
      {isOpen && (
        <div className="relative bg-black rounded-2xl landing-3xs:rounded-3xl p-3 landing-3xs:p-6 flex flex-row items-center gap-3 landing-3xs:gap-4 shadow-lg w-[calc(100vw-32px)] max-w-100 left-1/2 -translate-x-1/2 landing-3xs:left-0 landing-3xs:translate-x-0 min-h-16 landing-3xs:min-h-[unset]">
          <div
            className="absolute -top-2 -right-2 w-7 h-7 landing-3xs:w-8 landing-3xs:h-8 bg-grey-100 text-black rounded-full flex items-center justify-center z-20 shadow-console.log();
             cursor-pointer"
            onClick={() => setIsOpen(false)}
          >
            <XMarkIcon className="w-4 h-4 landing-3xs:w-5 landing-3xs:h-5" />
          </div>
          <img
            src={landingImages.discountTag}
            alt="Discount Tag"
            className="w-8 xsm:w-10 landing-3xs:w-20 object-contain z-20"
          />
          <div className="flex flex-row landing-3xs:flex-col justify-between items-center landing-3xs:items-start text-white flex-1">
            <div>
              <p className="text-xs landing-3xs:text-base leading">
                <span className="font-bold">Black Friday </span> sale for{" "}
                <span className="font-bold"> NEET PG </span> aspirants
              </p>
              <p className="text-xs landing-3xs:text-sm mt-1">
                Use code <span className="font-bold">BF1000</span> and get ₹1000 OFF!
              </p>
            </div>
            <a
              href="/portal/packages"
              className="mt-0 landing-3xs:mt-4 bg-white flex justify-center items-center text-green text-xs landing-3xs:text-sm min-w-16 font-bold px-2 xsm:px-3 landing-3xs:px-5 py-2 rounded-full hover:opacity-90 z-20 shadow-[0px_0px_28px_-4px_rgba(0,_0,_0,_0.24)] transition cursor-pointer"
            >
              <span className="max-xsm:hidden inline">Sign Up Now</span>
              <span className="max-xsm:inline hidden">Sign Up</span>
            </a>
          </div>

          <div className="absolute bottom-0 left-0 w-full h-full overflow-hidden rounded-l-2xl landing-3xs:rounded-l-3xl z-0">
            <div className="absolute -bottom-8 -left-6 landing-3xs:-bottom-4 landing-3xs:-left-8 w-20 h-20 landing-3xs:w-28 landing-3xs:h-28 bg-green opacity-50 rounded-full" />
          </div>
        </div>
      )}
    </div>
  );
};

export default DiscountBanner;
